// extracted by mini-css-extract-plugin
export default {"promptTranslate":"PromptTranslate_promptTranslate__jro2m","promptTranslateRow":"PromptTranslate_promptTranslateRow__No5nq"};